/**
 * Transforma um número para o formato financeiro.
 *
 * @param value Número como `string` ou `number`
 * @returns Número para o formato financeiro,
 *   retorna `'R$ 0,00'` caso o parâmetro seja inválido
 */
export const formatCurrency = (value: string | number) => {
  let numberValue;

  if (typeof value === 'string') {
    numberValue = parseFloat(value.replace(',', '.'));
  } else {
    numberValue = value;
  }

  if (!!value && !isNaN(numberValue)) {
    const decimalPlaces = value.toString().split(/[.,]/)[1]?.length || 2;
    return numberValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: decimalPlaces > 2 ? decimalPlaces : 2,
      maximumFractionDigits: decimalPlaces > 2 ? decimalPlaces : 2,
    });
  } else {
    return 'R$ 0,00';
  }
};

/**
 * Remove a formatação financeira do valor fornecido.
 *
 * @param value Número com formtação financeira
 * @returns O número sem formatação do tipo `number`,
 *   retorna como `0` caso o parâmetro seja inválido
 */
export const removeFormatCurrency = (value: string) => {
  if (!value) {
    return 0;
  }

  const number = parseFloat(value.toString().replace('R$', '').replace(/\./g, '').replace(',', '.').replace(/\s/g, ''));

  return isNaN(number) ? 0 : number;
};
